<template>
    <div>
        <a-card title="执行日志Console">
            <div slot="extra">
                <v-gobackbutton>返回</v-gobackbutton>
                <a-button type="primary" @click="refreshP" style="position:absolute;right:90px;">刷新</a-button>
            </div>
            
            <div class="content-wrapper">
                <section class="content">
                    <pre style="font-size:12px;position:relative;" >
                        <div id="logConsole"></div>
                        <li class="fa fa-refresh fa-spin" style="font-size: 20px;float: left;" id="logConsoleRunning" ></li>
                    </pre>
                </section>
            </div>
        </a-card>
    </div>
</template>

<script>
import $ from 'jquery'
export default {
    data() {
        return {
            logItem:{
                triggerCode:'',
                handleCode:'',
                executorAddress:'',
                triggerTime:'',
                id:''
            },
            fromLineNum:1,
            pullFailCount:0,
            logRun:null
        };
    },
    components: {
    },
    
    methods: {
        refreshP(){
            window.location.reload();
        },
        logRunStop(content){
            $('#logConsoleRunning').hide();
            this.logRun = window.clearInterval(this.logRun);
            $('#logConsole').append(content);
        },
        pullLog() {
        // pullFailCount, max=20
            if (this.pullFailCount++ > 20) {
                this.logRunStop('<span style="color: red;">终止请求Rolling日志,请求失败次数超上限,可刷新页面重新加载日志</span>');
                return;
            }

            // load
            console.log("pullLog, fromLineNum:" + this.fromLineNum);
            let that = this;
            that.$store.dispatch({
                type: 'jobcenter/logDetailCat',
                params: {
                    executorAddress:that.logItem.executorAddress,
                    triggerTime:new Date(that.logItem.triggerTime).getTime(),
                    logId:that.logItem.id,
                    fromLineNum:that.fromLineNum,
                    urlparams:false,
                }
            }).then((res) => {
                let data = res.data;
                if (data.code == 200) {
                    if (!data.content) {
                        console.log('pullLog fail');
                        return;
                    }
                    if (that.fromLineNum != data.content.fromLineNum) {
                        console.log('pullLog fromLineNum not match');
                        return;
                    }
                    if (that.fromLineNum > data.content.toLineNum ) {
                        console.log('pullLog already line-end');

                        // valid end
                        if (data.content.end) {
                            that.logRunStop('<br><span style="color: green;">[Rolling Log Finish]</span>');
                            return;
                        }

                        return;
                    }

                    // append content
                    that.fromLineNum = data.content.toLineNum + 1;
                    $('#logConsole').append(data.content.logContent);
                    that.pullFailCount = 0;

                    // scroll to bottom
                    scrollTo(0, document.body.scrollHeight);        // $('#logConsolePre').scrollTop( document.body.scrollHeight + 300 );

                } else {
                    console.log('pullLog fail:'+data.msg);
                }
            });
        }
    },
    mounted() {
        const { query } = this.$route;
        this.logItem.triggerCode = query.triggerCode;
        this.logItem.handleCode = query.handleCode;
        this.logItem.executorAddress = query.executorAddress;
        this.logItem.triggerTime = query.triggerTime;
        this.logItem.id = query.id;

        // trigger fail, end
        if ( !(query.triggerCode == 200 || query.handleCode != 0) ) {
            $('#logConsoleRunning').hide();
            $('#logConsole').append('<span style="color: red;">任务发起调度失败，无法查看执行日志</span>');
            return;
        }

        // pull first page
        this.pullLog();

        // handler already callback, end
        if (query.handleCode > 0) {
            this.logRunStop('<br><span style="color: green;">[Load Log Finish]</span>');
            return;
        }

        // round until end
        let that = this;
        that.logRun = setInterval(function () {
            that.pullLog()
        }, 3000);
    }
};
</script>

<style lang="less" scoped>
.content-wrapper {
    margin-left: 0;;
    min-height: calc(100vh - 101px);
    background-color: #ecf0f5;
    z-index: 800;
}
.content {
    min-height: 250px;
    padding: 15px;
    margin-right: auto;
    margin-left: auto;
    padding-left: 15px;
    padding-right: 15px;
}


.fa-spin {
    -webkit-animation: fa-spin 2s infinite linear;
    animation: fa-spin 2s infinite linear;
}

.fa {
    display: inline-block;
    font: normal normal normal 14px/1 FontAwesome;
    font-size: inherit;
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
</style>
